import gql from 'graphql-tag';
import { mutation } from 'services/graphql';

export const collaboratingUserCursorMovedOnSurfaceMutation = gql`
  mutation collaboratingUserCursorMovedOnSurface(
    $input: CollaboratingUserCursorMovedOnSurfaceInput!
  ) {
    collaboratingUserCursorMovedOnSurface(input: $input)
  }
`;

export default mutation(collaboratingUserCursorMovedOnSurfaceMutation);
